import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Payment from './payment';
import { Navbar } from './Navbar';
import { motion } from 'framer-motion';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PayScreen() {
  const location = useLocation();

  const { data, jobDescriptionFile, jobDescriptionText, resumeFile } = location.state || {};

  const [, setPaymentSuccess] = useState(false);

  return (
    <>
      <Navbar />
      <div className="flex flex-col  min-h-screen p-6 md:p-16">
        <ToastContainer />

        {/* Header Section */}
        <motion.h1
          className="text-4xl font-bold text-gray-800 text-center"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Complete Your Payment
        </motion.h1>
        <motion.p
          className="text-lg text-gray-600 text-center mt-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Unlock access to your detailed recommendations!
        </motion.p>

        {/* Payment Section */}
        <div className="flex justify-center mt-8">
          <motion.div
            className="bg-gradient-to-br  shadow-lg rounded-lg p-6 w-full md:w-1/2"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-lg font-semibold text-gray-700 text-center">
              Payment Plan
            </h2>
            <p className="text-base text-gray-600 text-center mt-4">
              Access AI-powered recommendations with just a few clicks.
            </p>

            {/* Pricing Box */}
            <div className="border border-gray-300 rounded-lg p-4 mt-4 text-center">
              <div className="text-3xl font-bold text-gray-800">
                $1.99 <span className="text-sm font-normal text-gray-500">per match</span>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                Recommendations are accessible only after payment.
              </p>
              <hr className="my-4" />
              <ul className="list-disc text-left text-gray-700 ml-6 space-y-2">
                <li>Applicable for one run</li>
                <li>Access all missing keywords</li>
                <li>Get detailed recommendations</li>
              </ul>
            </div>

            <div className="mt-6 border border-gray-400 rounded-lg p-4">
              <Payment
                setPaymentSuccess={setPaymentSuccess}
                data={data}
                jobDescriptionFile={jobDescriptionFile}
                jobDescriptionText={jobDescriptionText}
                resumeFile={resumeFile}
              />
            </div>

           
          </motion.div>
        </div>
      </div>
    </>
  );
  
}

export default PayScreen;
